import axios from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form"
import { toast } from 'react-toast'
import { Hearts } from "react-loader-spinner";
import { loadStripe } from "@stripe/stripe-js";

const baseURL = "https://api-landing.edianogama.com";

export const Form = () => {
    const formLength = 6;
    const [loader, setLoader] = useState(false);
    const checkout = async (data) => {
        const stripeClient = await loadStripe('pk_live_51Q70ISDmg4hthOqMCftdsKc72Rhnu7DfRESX61HEcAoBEJ1OirjnNy8nIi9D9HpG9oSi2mp1YzrLslGd5ZBW2X3t00qte0b1Cl');
        if (!stripeClient)  throw new Error("Stripe failed");

        const { id } = data.data.data;
        // setLoader(true);
        stripeClient.redirectToCheckout({ sessionId: id }).then(function(result) {
            if (result.error) {
                console.error(result.error.message);
                toast.error(result.error.message);
              }
        });
    }
    
    const inputFields = Array.from({ length: formLength });
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm()
      const onSubmit = (data) => {
        setLoader(true);
        const formData = new FormData();

        formData.append('title', data.couple);
        formData.append('plan_id', data.plan_id);
    
        for (let i = 1; i <= formLength; i++) {
            const photoKey = `photo-${i}`;
            const descriptionKey = `description-photo-${i}`;
    
            if (data[photoKey] && data[photoKey][0]) {
                formData.append(photoKey, data[photoKey][0]); 
            }
    
            if (data[descriptionKey]) {
                formData.append(descriptionKey, data[descriptionKey]);
            }
        }
        axios.post(baseURL+ '/v1/couples', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then((response) => {
            setLoader(false);
            if (response.data.status === 'sucess' || response.status === 200) {
                checkout(response.data);
            }
            toast.success("Cadastro com sucesso! Vamos te redirecionar. Aguarde!", {
                position: "top-center"
              });
        }).catch((error) => {
            console.log(error, 'error message')
            toast.error("Ocorreu um erro ao realizar seu cadastro!", {
                position: "top-center"
              });
        })
        .finally(() => {
            setLoader(false);
        });
      }

    return (
        <>
        {loader && (
            <div  className="bg-black/60 hs-overlay size-full d-block fixed top-0 start-0 z-[60] overflow-x-hidden overflow-y-auto flex justify-center items-center">
            <div className="flex justify-center items-center">
                <Hearts
                    height="140"
                    width="140"
                    color="#a63446"
                    ariaLabel="hearts-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                />
            </div>
            </div>
        )}
        <form onSubmit={handleSubmit(onSubmit)} className='form'>
        <div className="w-full text-left mt-4 lg:mt-0">
            <select 
                {...register("plan_id", { required: true })} 
                name="plan_id" 
                className="w-full bg-pink-500 text-white text-sm border border-pink-500 rounded-md px-3 py-6 md:py-6 transition duration-300 ease focus:outline-none focus:bg-pink-600 hover:bg-pink-600 shadow-sm focus:shadow cursor-pointer"
            >
                <option value="" disabled selected>Selecione um plano</option>
                <option value="1">Plano Básico - 10 dias - R$ 9.99</option>
                <option value="2">Plano Intermediário - 20 dias - R$ 14.99</option>
                <option value="3">Plano Premium - 30 dias - R$ 19.99</option>
            </select>
            {errors.plan && (
                <span className="text-red-500 text-xs italic">
                    Selecione um plano
                </span>
            )}
        </div>     
        <div className="flex flex-col lg:flex-row mt-4">
            <div className="w-full text-left">
                <input {...register("couple", { required: true })} name="couple" className="w-full bg-transparent placeholder:text-slate-400 text-white text-sm border border-[#fc94b4] rounded-md px-3 py-4 transition duration-300 ease focus:outline-none focus:border-blue-500 hover:border-blue-300 shadow-sm focus:shadow" placeholder="Nome do casal" />
                {errors.couple && <span className="text-red-500 text-xs italic">Este campo é obrigatório</span>}
            </div>
        </div>
        {inputFields.map((_, index) => (
            <div key={index} className='grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-2 mt-4'>
                <div className="w-full">
                    <input
                        id={`description-photo-${index + 1}`}
                        name={`description-photo-${index + 1}`}
                        {...register(`description-photo-${index + 1}`, { required: true })}
                        className="w-full bg-transparent placeholder:text-slate-400 text-white text-sm border border-[#fc94b4] rounded-md px-3 py-4 transition duration-300 ease focus:outline-none focus:border-blue-500 hover:border-blue-300 shadow-sm focus:shadow"
                        placeholder={`Descrição da foto ${index + 1}*`}
                    />
                    {errors.couple && <span className="text-red-500 text-xs italic">Este campo é obrigatório</span>}
                </div>
                <div className="flex w-full">
                    <input
                        id={`photo-${index + 1}`}
                        {...register(`photo-${index + 1}`, { required: true })}
                        type="file"
                        className="text-sm text-white
                            file:mr-5 file:py-4 file:px-6
                            file:rounded-md file:border-0
                            file:text-sm file:font-medium
                            file:bg-blue-50 file:text-white-700
                            hover:file:cursor-pointer hover:file:bg-amber-50
                            hover:file:text-amber-700"
                    />
                </div>
            </div>
        ))}
        <div className='flex gap-1 mt-4'>
            <button  type="submit" className="bg-pink-500 w-full hover:bg-[#a63446] text-white font-bold py-4 px-4 border border-white rounded">
                Criar nosso jogo
            </button>
        </div>
    </form>
    </>
    );
}